<template>
  <el-container class="container">
    <el-container class="main-content">
      <el-main class="main" id="layout-main">
        <Measure></Measure>
      </el-main>
      <el-aside v-show="!hide" class="aside-right" width="320px">
        <RightBlock></RightBlock>
      </el-aside>
    </el-container>
  </el-container>
</template>

<script>
import Measure from './Measure.vue'
import RightBlock from './RightBlock.vue'
export default {
  components: {
    Measure,
    RightBlock
  },
  data () {
    return {
      hide: false
    }
  },
  destroyed () {
    this.$event.$off('toolChange')
  },
  created () {
    this.$event.$on('toolChange', (activeIndex) => {
      if (activeIndex === '6') {
        this.hide = true
      } else {
        this.hide = false
      }
    })
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  overflow: hidden;
}

.aside-right {
  background: #F5F5F5;
  box-shadow: -1px 0px 0px 0px rgba(199,199,199,0.77);
  margin-left: 1px;
}

.el-main {
  position: relative;
  padding: 0;
}
.main-content{
  // height: 100%;
  overflow: auto;
}
</style>
